/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Input, ModalBody, ModalFooter, ModalHeader } from '@nextui-org/react';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { SettingsService } from '../../../services';

const ModalCreateSchoolYear = ({ item, onSuccess, onClose }) => {
  const { form, onChange, onSubmit } = useForm(item);

  const submit = async () => {
    const isSuccess = await onSubmit();
    if (isSuccess) onSuccess();
  }

  return (
    <>
      <ModalHeader className="flex flex-col gap-1">{!!item ? 'Editar' : 'Nuevo'}</ModalHeader>
      <ModalBody className="gap-8">
        <div className="flex flex-col flex-1 gap-4">
          <Input
            label="Año escolar"
            labelPlacement="outside"
            placeholder=" "
            radius="sm"
            variant="bordered"
            value={form.name}
            onValueChange={v => onChange(v, 'name')}
          />
          <div className="grid grid-cols-2 gap-4">
            <Input
              label="Inicio"
              labelPlacement="outside"
              placeholder=" "
              type="date"
              radius="sm"
              variant="bordered"
              value={form.init_date}
              onValueChange={v => onChange(v, 'init_date')}
            />
            <Input
              label="Finalización"
              labelPlacement="outside"
              placeholder=" "
              type="date"
              radius="sm"
              variant="bordered"
              value={form.end_date}
              onValueChange={v => onChange(v, 'end_date')}
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button variant="light" onPress={onClose}>Cerrar</Button>
        <Button className="bg-green" color="primary" onPress={submit}>Guardar</Button>
      </ModalFooter>
    </>
  )
}

const useForm = (item) => {
  const initialForm = {
    id: null,
    name: '',
    init_date: '',
    end_date: '',
  };

  const user = useSelector(state => state.user);
  const [form, setForm] = useState(initialForm);

  const onChange = (value, target) => {
    setForm(s => ({ ...s, [target]: value }));
  }

  const onError = (msg) => {
    toast.error(msg);
    return false;
  }

  const isValidForm = () => {
    if (!form.name)
      return onError('Debe nombrar el año escolar');

    if (!form.init_date)
      return onError('Debe indicar la fecha de inicio');

    if (!form.end_date)
      return onError('Debe indicar la fecha de finalización');

    return true;
  }

  const onSubmit = async () => {
    if (!isValidForm()) return;
    const isEditing = !!form.id;
    form.school_id = user?.id;

    try {
      isEditing
        ? await SettingsService.school.updateSchoolYear(form)
        : await SettingsService.school.createSchoolYear(form);

      toast.success(`Año escolar ${isEditing ? 'actualizado' : 'creado'} correctamente`);
      return true;

    } catch (error) {
      onError(String(error?.message ?? error));
      return false;
    }
  }

  useEffect(() => {
    if (item) {
      setForm({
        id: item.id,
        name: item.name,
        init_date: item.init_date,
        end_date: item.end_date,
      });
    }
  }, []);


  return {
    form,
    onChange,
    onSubmit,
  }
}

export default ModalCreateSchoolYear;
